import styled from "styled-components";
import { ReactComponent as Save_icon } from "../../../../assets/img/icons/save.svg";

const SavedSearch = (props) => {
  return (
    <>
      <Wrapper>
        <div className={`${props?.disabled ? "disable-click" : ""} saved-search`}>
          {props.label}
          <div className="save-icon">
            <Save_icon />
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default SavedSearch;

SavedSearch.defaultProps = {
  label: "Save search…",
};

const Wrapper = styled.div`
  .saved-search {
    border: 1px solid #dadada;
    border-radius: 8px;
    background: #fff;
    padding: 0 0 0 10px;
    color: #7e7e7e;
    font-size: 16px;
    font-weight: 500;
    font-family: "Roboto", sans-serif;
    line-height: 40px;
    cursor: pointer;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 11px;
      padding: 0 0 0 8px;
      border-radius: 6px;
      line-height: 28px;
    }
    .save-icon {
      border-left: 1px solid #dddddd;
      display: inline-block;
      padding: 0 10px 0 8px;
      margin: 10px 0 10px 5px;
      float: right;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        padding: 0 3px;
        margin: 10px 3px 10px 5px;
      }
      svg {
        float: left;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 10px;
          height: 10px;
        }
      }
    }
    &.disabled {
      opacity: 0.4;
    }
  }
  .disable-click {
    opacity: 0.4;
    pointer-events: none;
  }
`;
